var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { BaseSingletonService, Singleton } from '~/services/service.base';
import { makeObservable, observable, runInAction } from 'mobx';
import { MobxQuery } from '~/tools/mobx.query';
import { api } from '~/tools/api';
import { EApiUrl } from '~/tools/api/types';
import { UIOpenService } from '~/services/service.ui';
import { plainToInstance } from 'class-transformer';
import { ModelCategoryProperty } from '~/models/model.category.property';
export let ServiceCategoryProperties = class ServiceCategoryProperties extends BaseSingletonService {
    openDialogService;
    categoryProperties;
    currentCategory;
    communityId;
    constructor(openDialogService) {
        super();
        this.openDialogService = openDialogService;
        makeObservable(this);
        this.setCommunityId(17);
    }
    setCommunityId(communityId) {
        this.communityId = communityId;
    }
    setCategory(category) {
        this.currentCategory = category;
    }
    getProperties() {
        return new MobxQuery({
            queryFn: (() => this.currentCategory
                ? api
                    .get(`${EApiUrl.communities}/${this.communityId}/categories/${this.currentCategory.id}/${EApiUrl.properties}`)
                    .then(response => {
                    runInAction(() => (this.categoryProperties = plainToInstance(ModelCategoryProperty, response.data)));
                })
                : undefined),
        }).query();
    }
};
__decorate([
    observable,
    __metadata("design:type", typeof (_b = typeof TPropertyCategory !== "undefined" && TPropertyCategory) === "function" ? _b : Object)
], ServiceCategoryProperties.prototype, "categoryProperties", void 0);
__decorate([
    observable,
    __metadata("design:type", typeof (_c = typeof TCategory !== "undefined" && TCategory) === "function" ? _c : Object)
], ServiceCategoryProperties.prototype, "currentCategory", void 0);
ServiceCategoryProperties = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof UIOpenService !== "undefined" && UIOpenService) === "function" ? _a : Object])
], ServiceCategoryProperties);
